export enum ButtonVariant {
  Default,
  Primary,
  Plain,
  Action
}
